import { getApi, putApi } from './Api';

export const getDeviceList = async (count) => {
  const url = `/admin/device/all/page?page=${count}&size=15`;
  try {
    const response = await getApi(url);
    return response;
  } catch (e) {
    console.log('Error => ', e);
    throw e;
  }
};

export const getSerachDeviceList = async (value, count) => {
  const url = `/admin/device/getDeviceName/page/${value}?page=${count}&size=15`;
  try {
    const response = await getApi(url);
    return response;
  } catch (e) {
    console.log('Error => ', e);
    throw e;
  }
};

export const getDeviceID = async (id) => {
  const url = `admin/device/${id}`;
  try {
    const response = await getApi(url);
    return response;
  } catch (e) {
    console.log('Error => ', e);
    throw e;
  }
};

export const updateDevice = async (id, data) => {
  const url = `/admin/device/${id}`;
  try {
    const response = await putApi(url, data);
    return response;
  } catch (e) {
    console.log('Error => ', e);
    throw e;
  }
};

export const disconnectDevice = async (id) => {
  const url = `/admin/device/delete/device-hospital?uid=${id}`;
  try {
    const response = await getApi(url);
    return response;
  } catch (e) {
    console.log('Error => ', e);
    throw e;
  }
};

export const getDeviceHospital = async (id) => {
  const url = `/admin/device/hospital/${id}`;
  try {
    const response = await getApi(url);
    return response;
  } catch (e) {
    console.log('Error => ', e);
    throw e;
  }
};
